import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ResponseStatus } from '@app/core/enums/response-status.enum';
import { HttpServerResponse } from '@app/core/models/response.model';
import { LoggerService } from '@app/core/services/logger.service';
import { SaveObjectInLocalServiceService } from '@app/core/services/save-object-in-local-service.service';
import { AuthenticationService } from '@app/modules/authentication/services/authentication.service';

const logger = new LoggerService('LogoutModalComponent');

@Component({
  selector: 'dhl-logout-modal',
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.scss']
})
export class LogoutModalComponent {
  constructor(private readonly authService: AuthenticationService, private readonly storage: SaveObjectInLocalServiceService) {}

  public imagealert: string = '../../../../assets/images/login/ic_alert.png';

  isVisibleModalLogout!: boolean;

  @Input() isVisibleLogoutModalChild!: boolean;
  @Output() isVisibleLogoutModalEmit = new EventEmitter<boolean>();

  hiddenModalLogout() {
    this.isVisibleModalLogout = false;
    this.isVisibleLogoutModalEmit.emit(this.isVisibleModalLogout);
  }
  hiddenModalLogoutAndCloseSession() {
    this.logoutSession();
    sessionStorage.clear();
    this.isVisibleModalLogout = false;
    this.isVisibleLogoutModalEmit.emit(this.isVisibleModalLogout);
  }

  logoutSession() {
    this.authService.logout().subscribe({
      next: (response: HttpServerResponse<unknown>) => {
        if (response.status === ResponseStatus.Ok) {
          logger.info(response);
          this.storage.removeObject('session');
          if (this.storage.getObject('persistenceSession')) {
            this.storage.removeObject('persistenceSession');
          }
          window.location.href = '/home/homepage';
        }
      },
      error: (e) => {
        logger.error(e);
      }
    });
  }

  handleChildVariableChange(newChildVariableValue: boolean) {
    this.isVisibleModalLogout = newChildVariableValue;
  }
}
